export function wakeAzure() {
	if (typeof window === "undefined") return;

	fetch("/api/wake", { cache: "no-store" }).catch(() => {});
}
